import Api from './Api'

export default {
  async show(parameters) {
    const api = await Api()
    return api.post('environments', parameters)
  },
  async delete(parameters) {
    const api = await Api()
    return api.post('environment/delete', parameters)
  },
  async update(parameters) {
    const api = await Api()
    return api.post('environment/update', parameters)
  },
  async create(parameters) {
    const api = await Api()
    return api.post('new-environment', parameters)
  }
}